import React from 'react';
import Modal from '@ui-components/Modal';

interface MarkAtOfficeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isMarking: boolean;
}

export const MarkAtOfficeModal: React.FC<MarkAtOfficeModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isMarking,
}) => {
  return (
    <Modal
      title="Conferma presenza negli uffici"
      opened={isOpen}
      onExit={onClose}
      maxWidth="w-full sm:max-w-md"
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-700 font-bold">
          Referto già presente?
        </p>
        <p className="text-sm text-gray-600">
          Questa azione segnalerà che il referto è già stato archiviato e non è più necessario caricarlo digitalmente.
        </p>
        
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            disabled={isMarking}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Annulla
          </button>
          <button
            onClick={onConfirm}
            disabled={isMarking}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {isMarking ? (
              <>
                <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Elaborazione...
              </>
            ) : (
              'Conferma'
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};
